export default __webpack_public_path__ + "static/media/siyahi.81600670.png";